var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"benefits-title"},[_c('div',{staticClass:"container"},[_c('span',[_vm._v("A plataforma meus pedidos")])])])}]

export { render, staticRenderFns }